import Ably from "ably";

export default {
    install(Vue, options = {}) {
        const apiKey = options.apiKey;
        const channelName = options.channel || "default";

        if (!apiKey) {
            console.error("[Websocket] Missing Ably API key");
            return;
        }

        // Connexion Ably (version browser OK)
        const ably = new Ably.Realtime({
            key: apiKey
        });

        ably.connection.once("connected", () => {
            console.log("[Websocket] Connected to Ably");
        });

        const channel = ably.channels.get(channelName);

        const websocket = {
            /**
             * Publish a message to the channel
             */
            push(event, data) {
                return new Promise((resolve, reject) => {
                    channel.publish(event, data, err => {
                        if (err) {
                            console.error("[Websocket] Publish error:", err);
                            reject(err);
                        } else {
                            resolve(true);
                        }
                    });
                });
            },

            /**
             * Subscribe to a specific event
             */
            receive(event, callback) {
                channel.subscribe(event, msg => {
                    callback(msg.data, msg);
                });
            }
        };

        Vue.prototype.$websocket = websocket;
    }
}
